<template>
  <div class="container page">
    <div class="header">
      <!-- 顶部导航栏 -->
      <van-nav-bar :title="$t('recharge.recharge')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()" />
        </template>
        <!-- <template #right>
          <span class="nav-right" @click="$router.push({ path: '/RechargeRecord' })">
            {{ $t("recharge.recharge_record") }}
          </span>
        </template> -->
      </van-nav-bar>
      <!-- 当前余额 -->
      <div class="info">
        <p class="title">
          {{ $t("recharge.curr_balance") }}({{ $t("reservation.unit") }})
        </p>
        <p class="value">{{ this.balance }}</p>
      </div>
      <!-- 充值表单 -->
      <div class="content recharge">
        <van-form @submit="onSubmit">
          <div class="form-item">
            <div class="form-item-title">{{ $t("recharge.input_money") }}</div>
            <div style="height: 65px">
              <van-field v-model="money" name="money" label="Rp" style="font-size: 16px;"
                :placeholder="$t('recharge.input_money')" />
            </div>
          </div>
          <div class="form-item upload_line">
            <div class="form-item-title">{{ $t("recharge.upload_img") }}</div>
            <van-uploader v-model="fileList" :max-count="1" />
          </div>
          <div class="form-item">
            <div style="margin: 16px">
              <van-button round block type="info" native-type="submit">kirim</van-button>
            </div>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import imgUpload from '../../http/imgUpload'
import Vue from "vue";
import { Form, Field, RadioGroup, Radio, Uploader } from "vant";
Vue.use(Form).use(Field).use(RadioGroup).use(Radio).use(Uploader);

export default {
  data() {
    return {
      balance: 0,
      pay_way: "Mexicopay",
      win_money: 0,
      money: "",
      personalreport: {},
      fileList: [],
    };
  },
  mounted() {
    this.balance = this.numyn(this.$route.query.balance)
  },
  methods: {
    numyn(val) {
      val = '' + val // 转换成字符串
      let int = val
      int = int.split('').reverse().join('') // 翻转整数
      let temp = '' // 临时变量
      for (let i = 0; i < int.length; i++) {
        temp += int[i]
        if ((i + 1) % 3 === 0 && i !== int.length - 1) {
          temp += ',' // 每隔三个数字拼接一个逗号
        }
      }
      temp = temp.split('').reverse().join('') // 加完逗号之后翻转
      return temp // 返回
    },
    back() {
      return window.history.back();
    },

    //拉起支付
    async onSubmit() {
      const imgFile = this.fileList[0]
      const money = this.money
      if (!money) return this.$toast(this.$t("recharge.input_money"));
      if (!imgFile) return this.$toast(this.$t("recharge.upload_img"));
      const img_path = await imgUpload(imgFile.file)
      if (!img_path) return this.$toast(this.$t("recharge.upload_img"));

      this.$http({
        method: 'post',
        url: 'rechargePost',
        data: { money, img_path }
      }).then(res => {
        if (res.code === 200) {
          this.$toast(this.$t("recharge.success_tip"));
          this.fileList = []
          this.money = ''
        }
        else this.$toast.fail(res.msg);
      })
    },

    getPersonalreport() {
      this.$http({
        method: "get",
        url: "user_get_personalreport",
      }).then((res) => {
        if (res.code === 200) {
          this.personalreport = res.data;
          this.win_money =
            this.personalreport.win_money - this.personalreport.play_money;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getPersonalreport();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.recharge {
  padding: 10px 30px;
}

.van-cell {
  line-height: 65px !important;
}

.van-button {
  height: 87px !important;
}

.van-button__text {
  color: #fff !important;
}

/deep/.van-radio__icon {
  font-size: 30px !important;
}

/deep/.van-radio__label {
  margin-left: 25px !important;
  font-size: 35px !important;
}

/deep/.van-radio {
  height: 65px !important;
}

.form-item {
  margin-top: 40px;
}

.form-item-title {
  width: 100%;
  font-size: 25px;
  font-weight: bold;
  color: #999;
  margin-bottom: 20px;
}

.recharge span {
  font-size: 4vw;
  color: #868686;
  font-weight: 500;
}

.container .header .info {
  background: var(--color-core-blue-100, #0071dc);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 10px;
  margin: auto;
}

.container .header .info .title {
  font-size: 25px;
  color: #e5e5e5;
}

.container .header .info .value {
  margin: 10px auto;
  color: #fff;
  font-size: 50px;
  border-bottom: 1px solid #fff;
}

.container .header .info .tip {
  font-size: 30px;
  color: #e5e5e5;
}

.container .content {
  flex: 1;
  // background: #000;
}

.van-button--info {
  background-color: var(--color-core-blue-100, #0071dc);
  border: none;
}

.upload_line {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  /deep/ .van-uploader {
    zoom: 4;

    .van-uploader__wrapper {
      background: #fff;

      .van-uploader__upload,
      .van-uploader__preview {
        background: #fff;
        margin: 0;

        img {
          border-radius: 0;
        }
      }
    }
  }
}

/deep/.van-field {
  border-radius: 8px;
  box-shadow: 0 0 10px 0 var(--color-core-blue-100, #0071dc);
  overflow: hidden;
}

/deep/.van-uploader {
  border-radius: 2px;
  box-shadow: 0 0 4px 0 var(--color-core-blue-100, #0071dc);
  overflow: hidden;
}
</style>